import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ModalController } from 'ionic-angular'
import { ConfirmDialogPage } from '@ar2/common'
/**
 * タブグループ
 *【2ndデザイン:secondary:boolean】
 *【タブリスト:tabs:{label:string,value:string}[]】
 *【選択状態:activeTab:string】
 *【確認ダイアログ:showConfirm: boolean = false】
 *【確認ダイアログ設定:confirmDialogConfig: {title?: string, message?: string, cancelButtonTitle?: string, okButtonTitle?: string, showCloseButton?: boolean, } = { title: 'Confirm', message: 'Do you accept that changing the tab will discard your changes?', showCloseButton: false }】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tabs',
  templateUrl: './tabs.html',
  styles: [`
    
  `]
})
export class Tabs extends BaseWidget {
  /**
   * 選択状態の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択状態に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * タブリスト
   */
  @Input() tabs:{label:string,value:string}[]

  /**
   * 選択状態
   */
  @Input() activeTab:string

  /**
   * 確認ダイアログ
   */
  @Input() showConfirm: boolean = false

  /**
   * 確認ダイアログ設定
   */
  @Input() confirmDialogConfig: {title?: string, message?: string, cancelButtonTitle?: string, okButtonTitle?: string, showCloseButton?: boolean, } = { title: 'Confirm', message: 'Do you accept that changing the tab will discard your changes?', showCloseButton: false }

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * タブの選択状態を変更する
   * 
   * @param {any} res 
   * @memberof Tabs
   */
  selectTab(res) {
    const value = res.value;
    const ev = res.event;
    if (this.showConfirm) {
      const modalCtrl = this.injector.get(ModalController);
      const confirmModal = modalCtrl.create(
        ConfirmDialogPage,
        this.confirmDialogConfig
      );
      confirmModal.onDidDismiss(data => {
        if (data.value === 'ok') {
          this.updateViewModel(ev, value);
        }
      })
      confirmModal.present()
    } else {
      this.updateViewModel(ev, value);
    }
  }
  /**
   * View Modelを更新する
   * 
   * @param {Event} e 
   * @param {*} value 
   * @memberof Tabs
   */
  updateViewModel(e: Event, value: any) {
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:e.type, source:e},
      `update by ${this.id}`,
    ))
    this.on(e)
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/tab/tabs/tabs.component.ts